module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "liveParent"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("KV直播")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("查询直播")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.liveListData,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([
      ["default", function(props) {
        return [_c('el-form', {
          staticClass: "live-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "KV直播ID"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.id))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "投放公司"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.fromCompany))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "标题"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.liveTitle))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "创建者"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.userName))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "创建时间"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.createTime))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "更新时间"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.updateTime))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "id": "liveUrl",
            "label": "直播源连接"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.liveUrl))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "id": "sourceUrl",
            "label": "直播服务连接"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.sourcePath + props.row.id))])])], 1)]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "KV直播ID",
      "width": "120",
      "header-align": "center",
      "align": "center"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.id))])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "标题",
      "header-align": "center",
      "align": "center"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.liveTitle))])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "投放公司",
      "width": "150",
      "header-align": "center",
      "align": "center"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.fromCompany))])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "创建者",
      "width": "180",
      "header-align": "center",
      "align": "center"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.userName))])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "header-align": "center",
      "align": "center",
      "width": "300"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.toLive(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": _vm._f("isLiveOfflineColor")(scope.row.liveOffline)
          },
          on: {
            "click": function($event) {
              _vm.contralLiveLine(scope.$index, scope.row)
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm._f("isLiveOffline")(scope.row.liveOffline)) + "\n        ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": _vm._f("isOpenCommentFilterColor")(scope.row.isOpenComment)
          },
          on: {
            "click": function($event) {
              _vm.contralComment(scope.$index, scope.row)
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm._f("isOpenCommentFilter")(scope.row.isOpenComment)) + "\n        ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.contralEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }]
    ])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": 1,
      "page-size": 10,
      "layout": "total,prev,pager,next,jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "size": "small",
      "top": "13%",
      "custom-class": "editDialog",
      "modal-append-to-body": false,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.editRules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "直播标题",
      "prop": "liveTitle"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.liveTitle),
      callback: function($$v) {
        _vm.form.liveTitle = $$v
      },
      expression: "form.liveTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "投放公司",
      "prop": "fromCompany"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.fromCompany),
      callback: function($$v) {
        _vm.form.fromCompany = $$v
      },
      expression: "form.fromCompany"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "isLiveBgImg"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": function($event) {
        _vm.changeIsLiveBgImg()
      }
    },
    model: {
      value: (_vm.form.isLiveBgImg),
      callback: function($$v) {
        _vm.form.isLiveBgImg = $$v
      },
      expression: "form.isLiveBgImg"
    }
  }, [_vm._v("设置背景图")])], 1), _vm._v(" "), _c('el-form-item', {
    ref: "liveBgImg",
    attrs: {
      "label": "",
      "prop": "liveBgImg"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.form.isLiveBgImg,
      "placeholder": "背景图链接（尺寸940px*1136px）"
    },
    model: {
      value: (_vm.form.liveBgImg),
      callback: function($$v) {
        _vm.form.liveBgImg = $$v
      },
      expression: "form.liveBgImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播源"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择直播源"
    },
    on: {
      "change": function($event) {
        _vm.changeLiveSource()
      }
    },
    model: {
      value: (_vm.form.liveSource),
      callback: function($$v) {
        _vm.form.liveSource = $$v
      },
      expression: "form.liveSource"
    }
  }, _vm._l((_vm.form.liveSourceList), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "缩略图",
      "prop": "otherImg"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.form.liveSource.otherImg,
      "placeholder": "背景图链接（尺寸940px*1136px）"
    },
    model: {
      value: (_vm.form.otherImg),
      callback: function($$v) {
        _vm.form.otherImg = $$v
      },
      expression: "form.otherImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播链接",
      "prop": "liveUrl"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.liveUrl),
      callback: function($$v) {
        _vm.form.liveUrl = $$v
      },
      expression: "form.liveUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播描述",
      "prop": "liveContent"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入直播描述"
    },
    model: {
      value: (_vm.form.liveContent),
      callback: function($$v) {
        _vm.form.liveContent = $$v
      },
      expression: "form.liveContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "isShare"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": function($event) {
        _vm.changeShare()
      }
    },
    model: {
      value: (_vm.form.isShare),
      callback: function($$v) {
        _vm.form.isShare = $$v
      },
      expression: "form.isShare"
    }
  }, [_vm._v("开启分享")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享链接",
      "prop": "shareUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.form.isShare,
      "placeholder": "请输入分享链接（选填）"
    },
    model: {
      value: (_vm.form.shareUrl),
      callback: function($$v) {
        _vm.form.shareUrl = $$v
      },
      expression: "form.shareUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享头图",
      "prop": "shareImg"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.form.isShare,
      "placeholder": "请输入分享头图，尺寸200x200（必填）"
    },
    model: {
      value: (_vm.form.shareImg),
      callback: function($$v) {
        _vm.form.shareImg = $$v
      },
      expression: "form.shareImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享标题",
      "prop": "shareTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.form.isShare,
      "placeholder": "请输入分享标题（必填）"
    },
    model: {
      value: (_vm.form.shareTitle),
      callback: function($$v) {
        _vm.form.shareTitle = $$v
      },
      expression: "form.shareTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享描述",
      "prop": "shareDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.form.isShare,
      "placeholder": "请输入分享描述（必填）"
    },
    model: {
      value: (_vm.form.shareDesc),
      callback: function($$v) {
        _vm.form.shareDesc = $$v
      },
      expression: "form.shareDesc"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editBtn()
      }
    }
  }, [_vm._v("确 认")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2f1c7a56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/kvlive/List.vue
// module id = 749
// module chunks = 1